import apiClient from './apiClient'

const request = async (promise) => {
  try {
    const res = await promise
    return res
  } catch (err) {
    if (err.response) {
      throw {
        message: err.response.statusText || 'Request failed',
        status: err.response.status,
        data: err.response.data,
        headers: err.response.headers
      }
    } else {
      throw { message: err.message || 'Network error' }
    }
  }
}

export const addObject = (type, object) => {
  if (object instanceof FormData) {
    return request(
      apiClient.post(`/${type}`, object, {
        headers: { 'Content-Type': undefined }
      })
    )
  } else {
    return request(apiClient.post(`/${type}`, object))
  }
}
export const editObject = (type, id, object) => request(apiClient.put(`/${type}/${id}`, object))

export const editObjectFilter = (type, params, object) => request(apiClient.put(`/${type}`, object, { params }))

export const getObject = (type, id) => request(apiClient.get(`/${type}/${id}`))

export const getObjects = (type, params) => request(apiClient.get(`/${type}`, { params }))

export const getObjectsWithFilter = (type, where, subwhere) =>
  request(
    apiClient.get(`/${type}`, {
      params: {
        where: JSON.stringify(where),
        subwhere: JSON.stringify(subwhere)
      },
      paramsSerializer: { indexes: null }
    })
  )

export const deleteObject = (type, id) => request(apiClient.delete(`/${type}/${id}`))
